import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlertCallOfferComponent } from './components/alert-call-offer/alert-call-offer.component';
import { AlertJobOfferComponent } from './components/alert-job-offer/alert-job-offer.component';
import { AlertOtherComponent } from './components/alert-other/alert-other.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'appel-offre',
    pathMatch: 'full',
  },
  {
    path:'appel-offre',
    component:AlertCallOfferComponent,
  },
  {
    path:'offre-emploi',
    component:AlertJobOfferComponent,
  },
  {
    path:'liste-alert',
    component:AlertOtherComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertsRoutingModule { }
